export class DialogModelConfirmMultipleSOCancel {
    constructor(
      public orders: any
    ) {}
  }
  